import React from "react";
import { Helmet } from "react-helmet";

const TeamMemberAryanHalapara = () => {
    const pageUrl = "https://www.anmatics.com/team/aryan-halapara";
    const pageTitle = "Aryan Halapara | Software Engineer | SaaS Developer | Co-Founder at Anmatics Technologies";
    const pageDescription =
        "Aryan Halapara is the Co-Founder and Lead Software Engineer at Anmatics Technologies with 10+ years of experience in building scalable web applications, SaaS platforms, and modern software solutions. Creator of DecklePro.";

    const personSchema = {
        "@context": "https://schema.org",
        "@type": "Person",
        "@id": "https://www.anmatics.com/team/aryan-halapara#person",
        name: "Aryan Halapara",
        givenName: "Aryan",
        familyName: "Halapara",
        alternateName: [
            "Aaryan Halapara",
            "Aryan Halpara",
            "Aaryan Halpara",
            "Aaryan Halalara",
        ],
        url: pageUrl,
        mainEntityOfPage: {
            "@type": "WebPage",
            "@id": pageUrl,
        },
        description: pageDescription,
        image: "https://www.anmatics.com/profile_pic_aryan_halapara.png",
        jobTitle: "Co-Founder & Lead Software Engineer",
        address: {
            "@type": "PostalAddress",
            addressLocality: "Morbi",
            addressRegion: "Gujarat",
            addressCountry: "IN",
        },
        hasOccupation: [
            {
                "@type": "Occupation",
                name: "Co-Founder & Lead Software Engineer",
                occupationLocation: {
                    "@type": "City",
                    name: "Morbi, Gujarat, India",
                },
                estimatedSalary: {
                    "@type": "MonetaryAmountDistribution",
                    name: "Software Engineering",
                },
            },
            {
                "@type": "Occupation",
                name: "Senior Software Engineer",
                occupationLocation: {
                    "@type": "City",
                    name: "Pune, Maharashtra, India",
                },
            },
            {
                "@type": "Occupation",
                name: "UI Specialist",
                occupationLocation: {
                    "@type": "City",
                    name: "Pune, Maharashtra, India",
                },
            },
            {
                "@type": "Occupation",
                name: "Software Engineer",
                occupationLocation: {
                    "@type": "City",
                    name: "Pune, Maharashtra, India",
                },
            },
        ],
        alumniOf: [
            // Optionally, add education history here if desired
        ],
        worksFor: {
            "@type": "Organization",
            name: "Anmatics Technologies",
            url: "https://www.anmatics.com",
        },
        sameAs: [
            "https://www.linkedin.com/in/aryanhalapara/",
            "https://www.facebook.com/aryan.halapara",
            "https://github.com/aryanhalapara",
        ],
        knowsAbout: [
            "SaaS",
            "Web Development",
            "Software Architecture",
            "Frontend Development",
            "Backend Development",
            "Angular",
            "React.js",
            "TypeScript",
            "JavaScript",
            "Node.js",
            "API Development",
            "System Design",
            "Cloud Applications",
            "Optimization Algorithms",
            "Product Engineering",
        ],
        workExample: [
            {
                "@type": "SoftwareApplication",
                name: "DecklePro",
                applicationCategory: "BusinessApplication",
                operatingSystem: "Web",
                url: "https://www.anmatics.com/product-details",
            },
        ],
        affiliation: {
            "@type": "Organization",
            name: "Anmatics Technologies",
        },
    };

    const organizationSchema = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "@id": "https://www.anmatics.com/#organization",
        name: "Anmatics Technologies",
        url: "https://www.anmatics.com",
        logo: "https://www.anmatics.com/anmatics_logo_square_512.png",
        sameAs: [
            "https://www.linkedin.com/company/anmatics-technologies/",
        ],
    };

    const contactSchema = {
        "@context": "https://schema.org",
        "@type": "ContactPoint",
        contactType: "Business Inquiries",
        email: "mailto:info@anmatics.com",
        availableLanguage: ["English", "Hindi", "Gujarati"],
        url: pageUrl,
    };

    const faqSchema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
            {
                "@type": "Question",
                name: "Who is Aryan Halapara?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "Aryan Halapara is a Software Engineer and SaaS Product Developer with 10+ years of experience. He is the Co-Founder and Lead Software Engineer at Anmatics Technologies and the creator of DecklePro.",
                },
            },
            {
                "@type": "Question",
                name: "What services does Aryan Halapara provide?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "Aryan Halapara provides SaaS product development, web application development, frontend engineering (Angular), backend & API development, system architecture, and software modernization services.",
                },
            },
            {
                "@type": "Question",
                name: "How can I contact Aryan Halapara?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "You can connect with Aryan Halapara via LinkedIn or reach out through Anmatics Technologies for collaboration and software development work.",
                },
            },
        ],
    };
    return (
        <>
            <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content={pageDescription} />
                <link rel="canonical" href={pageUrl} />

                {/* Open Graph */}
                <meta property="og:type" content="profile" />
                <meta property="og:title" content={pageTitle} />
                <meta property="og:description" content={pageDescription} />
                <meta property="og:url" content={pageUrl} />
                <meta
                    property="og:image"
                    content="https://www.anmatics.com/profile_pic_aryan_halapara.png"
                />
                <meta property="og:site_name" content="Anmatics Technologies" />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={pageTitle} />
                <meta name="twitter:description" content={pageDescription} />
                <meta
                    name="twitter:image"
                    content="https://www.anmatics.com/profile_pic_aryan_halapara.png"
                />

                {/* Rich Snippet / Schema */}
                <script type="application/ld+json">
                    {JSON.stringify(personSchema)}
                </script>

                <script type="application/ld+json">
                    {JSON.stringify(organizationSchema)}
                </script>

                <script type="application/ld+json">
                    {JSON.stringify(contactSchema)}
                </script>

                <script type="application/ld+json">
                    {JSON.stringify(faqSchema)}
                </script>
            </Helmet>

            <section className="team-member-profile container mx-auto py-12 px-4">
                <div className="profile-header text-center mb-8">
                    <img
                        src={"https://www.anmatics.com/profile_pic_aryan_halapara.png"}
                        alt="Aryan Halapara"
                        className="w-32 h-32 rounded-full mx-auto object-cover"
                    />
                    <h1 className="text-3xl font-bold mt-4">Aryan Halapara</h1>
                    <p className="text-lg text-gray-700">Co-Founder & Lead Software Engineer</p>

                    <p className="profile-summary">
                        Aryan Halapara is a Software Engineer and SaaS Product Developer with 10+ years of experience in building scalable web applications, APIs, and enterprise solutions.
                    </p>
                </div>

                <div className="profile-bio text-gray-800 space-y-4">
                    <p>
                        Aryan Halapara is a <strong>Co-Founder and Lead Software Engineer</strong> at
                        Anmatics Technologies with <strong>10+ years of professional experience</strong>
                        in building scalable web applications, SaaS products, and enterprise software
                        solutions. He specializes in modern frontend and backend development, system
                        design, and building high-performance applications.
                    </p>

                    <p>
                        At Anmatics Technologies, Aryan leads product development and engineering
                        execution across multiple software initiatives. One of his key products is
                        <strong> DecklePro</strong>, a deckle matching optimization platform designed
                        for paper mills. He enjoys working on challenging business problems across
                        different industries where software can create measurable impact.
                    </p>

                    <p>
                        Aryan is passionate about scalable architecture, clean code practices, and
                        delivering production-ready software. He is open to collaborating on
                        <strong> SaaS development</strong>, <strong>web application development</strong>,
                        <strong> API engineering</strong>, and <strong>product modernization </strong>
                        projects where strong engineering and long-term maintainability matter.
                    </p>
                </div>

                <div className="links-section mt-8">
                    <h2 className="text-2xl font-semibold mb-3">Connect with Aryan</h2>
                    <ul className="flex gap-6 text-blue-600">
                        <li>
                            <a href="https://www.linkedin.com/in/aryanhalapara/" target="_blank" rel="noopener noreferrer">
                                LinkedIn
                            </a>
                        </li>
                        <li>
                            <a href="https://www.facebook.com/aryan.halapara" target="_blank" rel="noopener noreferrer">
                                Facebook
                            </a>
                        </li>
                        <li>
                            <a href="https://github.com/aryanhalapara" target="_blank" rel="noopener noreferrer">
                                GitHub
                            </a>
                        </li>
                    </ul>
                </div>

                <div className="skills-section mt-10">
                    <h2 className="text-2xl font-semibold mb-3">Technical Skills</h2>
                    <p className="text-gray-700">
                        JavaScript • TypeScript • Angular • Angular Expert • Node.js • Web Development • Frontend Architecture • API Design • Scalable Systems
                    </p>
                </div>

                <div className="services-section mt-10">
                    <h2 className="text-2xl font-semibold mb-3">Services / What I Can Help With</h2>
                    <p className="services-intro">
                        If you're looking for a reliable engineer to build or scale your product, I can help you with end-to-end software development and long-term technical support.
                    </p>

                    <div className="services-grid">
                        <div className="service-card">
                            <h3>SaaS Product Development</h3>
                            <p>
                                From MVP to production-grade SaaS platforms, including dashboards, user management, billing flows, and performance optimization.
                            </p>
                        </div>

                        <div className="service-card">
                            <h3>Frontend Engineering</h3>
                            <p>
                                Building modern, responsive, high-performance UIs using Angular, React, TypeScript, and component-driven architecture.
                            </p>
                        </div>

                        <div className="service-card">
                            <h3>Backend & API Development</h3>
                            <p>
                                Designing scalable APIs and backend services using Node.js and modern architecture patterns with clean and maintainable code.
                            </p>
                        </div>

                        <div className="service-card">
                            <h3>System Design & Architecture</h3>
                            <p>
                                Helping teams improve scalability, security, modular architecture, code quality, and long-term maintainability.
                            </p>
                        </div>

                        <div className="service-card">
                            <h3>Optimization & Automation</h3>
                            <p>
                                Building algorithm-driven solutions for planning, allocation, and automation problems that reduce cost and improve efficiency.
                            </p>
                        </div>

                        <div className="service-card">
                            <h3>Product Modernization</h3>
                            <p>
                                Migrating legacy systems to modern frameworks, improving UX, optimizing performance, and implementing best engineering practices.
                            </p>
                        </div>
                    </div>

                    <div className="services-cta">
                        <p>
                            <strong>Interested in working together?</strong> Reach out via LinkedIn or email for collaboration, consulting, or development work.
                        </p>
                    </div>
                </div>

                <div className="experience-section mt-10">
                    <h2 className="text-2xl font-semibold mb-3">Professional Experience</h2>

                    <div className="experience-timeline">
                        <div className="experience-item">
                            <div className="timeline-dot"></div>
                            <h3>Co-Founder & Lead Software Engineer</h3>
                            <p className="experience-company">Anmatics Technologies • Full-time</p>
                            <p className="experience-duration">Apr 2024 - Present • Morbi, Gujarat, India (Hybrid)</p>
                            <p className="experience-summary">
                                Leading product development and engineering teams at Anmatics Technologies, focusing on SaaS platforms and optimization solutions for manufacturing industries.
                            </p>
                        </div>

                        <div className="experience-item">
                            <div className="timeline-dot"></div>
                            <h3>Senior Software Engineer</h3>
                            <p className="experience-company">Robosoft Technologies • Full-time</p>
                            <p className="experience-duration">Jun 2022 - Mar 2024 • Pune, Maharashtra, India</p>
                            <p className="experience-summary">
                                Worked on modern web applications and enterprise-grade platforms using React.js and front-end architecture best practices.
                            </p>
                        </div>

                        <div className="experience-item">
                            <div className="timeline-dot"></div>
                            <h3>UI Specialist</h3>
                            <p className="experience-company">YASH Technologies • Full-time</p>
                            <p className="experience-duration">Mar 2019 - Jun 2022 • Pune, Maharashtra, India</p>
                            <p className="experience-summary">
                                Built responsive UI solutions, improved user experience, and contributed to large-scale web development projects.
                            </p>
                        </div>

                        <div className="experience-item">
                            <div className="timeline-dot"></div>
                            <h3>Software Engineer</h3>
                            <p className="experience-company">KPIT • Full-time</p>
                            <p className="experience-duration">Feb 2016 - Feb 2019 • Pune, Maharashtra, India</p>
                            <p className="experience-summary">
                                Started professional journey as a software engineer, gaining strong fundamentals in software development and collaborative engineering.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default TeamMemberAryanHalapara;